import './index.scss';

class SvgIcon {


    cross() {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" data-name="cross"><path d="M3.06 38.846a1.5 1.5 0 0 1-2.12-2.12L35.224 2.438a1.5 1.5 0 1 1 2.121 2.122L3.061 38.846Z"></path><path d="M2.65 4.56a1.5 1.5 0 0 1 2.12-2.12l34.286 34.285a1.5 1.5 0 1 1-2.121 2.121L2.649 4.561Z"></path></svg>`;
    }

    singleBackArrow() {
        return `<svg data-name="single-back-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 22L7 12L17 2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    }

    singleForwardArrow() {
        return `<svg data-name="single-forward-arrow"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 2L17 12L7 22"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    }
}

export default SvgIcon;